import type { documentTableOptions } from "./documentTableOptions";
import type { DocumentWithTags } from "./documentTableTypes";
import type { useTableDialogState } from "./useTableDialogState";

type Lookup = Pick<ReturnType<typeof documentTableOptions>, "store" | "documents"> &
  Pick<ReturnType<typeof useTableDialogState>, "versionDocsCache">;

function cachedVersionDocument(
  cache: Lookup["versionDocsCache"],
  docId: string
): DocumentWithTags | undefined {
  for (const entry of cache.values()) {
    const hit = entry.docs.find((version) => version.id === docId);
    if (hit) return hit;
  }
}

export function resolveTableDocument(options: Lookup, docId: string) {
  const storeDoc = options.store?.documents.get(docId);
  const propsDoc = options.documents?.find((doc) => doc.id === docId);
  return storeDoc || propsDoc || cachedVersionDocument(options.versionDocsCache, docId);
}
